import * as React from "react";

import { useStableId } from "Components/ui";
import { cn } from "utils/cn";

/**
 * The MetaHOS product mark (two peaks). Clients know MetaHOS, not SAP, so their pay pages carry
 * this mark instead of SAP's orbit logo. The gradient stops are the brand colors on purpose.
 */
const MetaHosMark: React.FC<{ className?: string }> = ({ className }) => {
  const id = useStableId("metahos");
  return (
    <svg
      viewBox="0 0 64 64"
      aria-hidden="true"
      className={cn("h-10 w-10 shrink-0", className)}
      data-ui="metahos-mark"
    >
      <defs>
        <linearGradient id={`${id}-blue`} x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#0B6FE1" />
          <stop offset="100%" stopColor="#1F9BFF" />
        </linearGradient>
        <linearGradient id={`${id}-teal`} x1="10%" y1="90%" x2="90%" y2="10%">
          <stop offset="0%" stopColor="#10B981" />
          <stop offset="100%" stopColor="#22D3EE" />
        </linearGradient>
      </defs>
      <path
        d="M10 52L30 14c2.2-4.2 8.4-4.2 10.6 0l20 38c2.2 4.1-.8 9-5.3 9H15.3c-4.5 0-7.5-4.9-5.3-9Z"
        fill={`url(#${id}-blue)`}
      />
      <path
        d="M26 52l14-26c1.6-3 5.8-3 7.4 0l14 26c2 3.7-.7 8-4.8 8H30.8c-4.1 0-6.8-4.3-4.8-8Z"
        fill={`url(#${id}-teal)`}
      />
    </svg>
  );
};

export default MetaHosMark;
